import { Card, Grid } from "@mui/material";
import Layout from "components/Layout";
import Strategy from "components/holdings/Management/Strategy";

const ManagementPage = () => {
  return (
    <Layout title="Management">
      <Card>
        <Grid container>
          <Grid item xs={12} padding={2}>
            <Strategy />
          </Grid>
        </Grid>
      </Card>
    </Layout>
  );
};

export default ManagementPage;
